// ABOUTME: The current time as state, advanced on an interval.
// ABOUTME: Lets time-based statuses update on their own, and keeps Date.now out of render.
import { useEffect, useState } from "react";

/** Milliseconds since the epoch, refreshed every `intervalMs` while mounted. */
export function useNow(intervalMs = 60_000): number {
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
